import { motion } from "framer-motion";
import { Clock, FileCheck, ShieldCheck, Home } from "lucide-react";

const items = [
  { icon: Clock, value: "20+", label: "Années au service des Genevois", sub: "Chantier après chantier, sans compromis" },
  { icon: FileCheck, value: "24h", label: "Devis reçu en 24h, toujours gratuit", sub: "Détaillé, ligne par ligne, sans engagement" },
  { icon: ShieldCheck, value: "100%", label: "Chantiers livrés dans les délais", sub: "Et garantis tous corps de métier" },
  { icon: Home, value: "Local", label: "Une famille, pas une boîte anonyme", sub: "Basés à Grand-Lancy, Genève" },
];

const ease = [0.16, 1, 0.3, 1];

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-cream py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease }}
          className="max-w-3xl mb-16"
        >
          <span className="eyebrow">Pourquoi nous choisir</span>
          <h2 className="mt-4 font-serif text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-normal">
            <span className="sr-only">Pourquoi Choisir DEM BAT pour Votre Rénovation à Genève. </span>
            Pourquoi des centaines de genevois <span className="italic text-bronze">nous font confiance.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.label}
                data-testid={`why-item-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.7, ease, delay: i * 0.1 }}
                className="bg-cream p-8 lg:p-10 group"
              >
                <Icon className="w-8 h-8 text-bronze mb-6 group-hover:scale-110 transition-transform duration-500" strokeWidth={1} />
                <div className="font-serif text-4xl lg:text-5xl text-charcoal mb-3 font-normal">
                  {it.value}
                </div>
                <div className="text-charcoal text-base font-medium">{it.label}</div>
                <div className="mt-1 text-charcoal-muted text-sm font-light">{it.sub}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
